/// <reference path="../../../../../typings.d.ts" />

import { Component } from '@angular/core';
import 'file-saver';
import { ContractModelService } from '../contracts.model.service';
import { ContractsAccrualsHttpUtil } from './contracts.accruals.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { ContractsHttpService } from '../../../../services/contracts/contracts.http.service';
import { ReportHttpService } from '../../../../services/report/report.http.service';
import { ActivatedRoute } from '@angular/router';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.accruals.component.html',
  providers: []
})

export class ContractsAccrualsComponent {

  model: any = {};
  list = [];
  futureAccruals = 0;
  payedAccruals = 0;
  selectedAccruals = [];
  printQuantity: any = 0;
  printAmount: any = 0;
  errorMessage: string;
  loading: boolean = false;
  typeList = [
    {label: 'Все обязательства', value: 'obligations'},
    {label: 'Основные обязательства', value: 'debt'},
    {label: 'Решения суда', value: 'judgement'}
  ];
  accrualsType = this.typeList[0].value;

  getContractsSubscription: any;

  fileName = 'invoice';

  constructor(private contractModelService: ContractModelService, private contractsHttpService: ContractsHttpService, private route: ActivatedRoute, private authUtil: AuthUtil, private reportHttpService: ReportHttpService) {
  }

  ngOnInit() {
    this.futureAccruals = this.contractModelService.getAccrualsConfig().futureAccruals;
    this.payedAccruals = this.contractModelService.getAccrualsConfig().payedAccruals;

    this.model = this.contractModelService.getData();
    this.list = this.cloneModel(this.model.accruals);
  }

  cloneModel(model) {
    if(model) {
      return model.map((item) => {
        let sl = this.selectedAccruals.findIndex((arItem) => {
              return arItem.id === item.id;
        });

        item.selected = sl > -1;
        return Object.assign({}, item);
      });
    }

    return [];
  }

  toggleShowFutureAccruals(status) {
    this.futureAccruals = status ? 1 : 0;
    this.getAccruals();
  }

  toggleShowPayedAccruals(status) {
    this.payedAccruals = status ? 1 : 0;
    this.getAccruals();
  }

  getAccruals() {

    this.loading = true;

    if(this.getContractsSubscription) {
      this.getContractsSubscription.unsubscribe();
    }
    
    let id = +this.route.parent.snapshot.paramMap.get('id');
    let data = {
      securityToken: StorageUtil.getToken(),
      futureAccruals: this.futureAccruals,
      payedAccruals: this.payedAccruals,
      accrualsType: this.accrualsType,
    };

    let requestParams = ContractsAccrualsHttpUtil.prepareParamsAccrualsContracts(data);
    this.getContractsSubscription = this.contractsHttpService.getSingleContract(id, requestParams).subscribe(
      data => {
        let response = data.json();
        if(this.authUtil.isError(response)) {
            this.contractModelService.setData(false);
            this.authUtil.checkErrorResponse(response);
        } else {
          this.model = data.json().response;
          this.list = this.cloneModel(this.model.accruals);
          this.contractModelService.setData(this.model);
          let accrualsConfig = {
            futureAccruals: this.futureAccruals,
            payedAccruals: this.payedAccruals,
          };
          this.contractModelService.setAccrualsConfig(accrualsConfig);
        }

        this.loading = false;
      },
      error => {
        this.loading = false;
      },
      () => {
      });
  }

  selectAccrual(accrualItem) {
    if (this.checkAccrualPaid(accrualItem)) {
      accrualItem.selected = false;
      return;
    }

    accrualItem.selected = !accrualItem.selected;

    if (!accrualItem.selected) {
      let isAccrualItemSelectedIndex = this.selectedAccruals.findIndex((item) => {
        return item.id === accrualItem.id;
      });

      if (isAccrualItemSelectedIndex > -1) {
        this.selectedAccruals.splice(isAccrualItemSelectedIndex, 1);
      }

      let amount = accrualItem.accrualAmount;
      this.printAmount = (Number(this.printAmount) - Number(amount)).toFixed(2);

    } else {
      let amount = accrualItem.accrualAmount;
      this.printAmount = (Number(this.printAmount) + Number(amount)).toFixed(2);
      this.selectedAccruals.push(accrualItem);
    }

    this.printQuantity = this.getPrintQuantity();

  }

  getPrintStatus() {
    return !!this.selectedAccruals.length;
  }

  getPrintQuantity() {
    return this.selectedAccruals.length;
  }

  getPrintAmount() {
    let amount: any = 0;
    for(let i = 0; i < this.selectedAccruals.length; i++) {
      let am = this.selectedAccruals[i].accrualAmount;
      amount = (Number(am) + amount).toFixed(2);
    }
    return amount;
  }

  resetSelected() {
    this.selectedAccruals = [];
    for(let i = 0; i < this.list.length; i++) {
      this.list[i].selected = false;
    }
  }

  downloadInvoice($event) {
    $event.preventDefault();
    this.loading = true;
    this.errorMessage = '';

    let accrualsIds = this.selectedAccruals.map(item => {
      return item.id;
    });

    let data = {
      securityToken: StorageUtil.getToken(),
      accrualsIds: accrualsIds.join('-'),
    };

    let requestParams = ContractsAccrualsHttpUtil.prepareParamsAccrualsInvoice(data);
    this.reportHttpService.getInvoice(requestParams)
      .map(res => {
        if(res.headers.get('content-disposition')) {
          this.fileName = res.headers.get('content-disposition').split('"')[1];
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          this.loading = false;
          if(blobContent) {
            saveAs(blobContent, this.fileName);
          } else {
            this.errorMessage = 'Произошла ошибка.';
          }
        },
        error => {
          this.errorMessage = 'Произошла ошибка.';
          this.loading = false;
        },
        () => {
          this.loading = false;
        });
  }

  checkAccrualPaid(accrual): boolean {
    return accrual.status === 'Оплачено';
  }

  ngOnDestroy() {
    if(this.getContractsSubscription) {
      this.getContractsSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/accruals/contracts.accruals.component.ts